/**
 * App init: ready document loaded
 * @param callback
 */
export const ready = (callback: () => void) => {
    if (document.readyState !== "loading") {
        callback()
    } else {
        document.addEventListener("DOMContentLoaded", callback)
    }
}